
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { iHotTypeGame } from '@/interface/hot-game';
import ShowItem from './show_item.vue';
@Component({ components: { ShowItem } })
export default class HotEdit extends Vue {
  // @Prop() list!: iHotGameDetails[];
  @Prop() hotGameTypeList!: iHotTypeGame[];
  @Prop() kind_id!: number;
  @Prop() endpoint!: number;
  topIndex: string = '1';
  kindIDIndex: string = '0';
  new_kind_id: number = this.kind_id;
  footList: object[] = [
    {
      logo: 'android',
      lable: '游戏',
    },
    {
      logo: 'example',
      lable: '云电脑',
    },
    {
      logo: 'user',
      lable: '我的',
    },
  ];

  KindTabChange(e: any) {
    this.new_kind_id = e.$attrs.id;
  }
  @Watch('topIndex')
  onChangeValue(newVal: number, oldVal: number) {
    if (newVal != oldVal) {
      if (newVal == 0) {
        this.new_kind_id = this.hotGameTypeList[0].id;
      }
    }
  }
}
